import {
    ComponentRef,
    Directive,
    ElementRef,
    inject,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewContainerRef
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Icons } from '../../../icon/constants/icons.constants';
import { IconComponent } from '../../../icon/icon.component';
import { MenuPanel } from '../../menu.component';

@Directive({
    selector: '[nw-menu-trigger-button]'
})
export class MenuTriggerButtonDirective implements OnInit, OnDestroy {
    @Input() nwMenuTriggerFor!: MenuPanel | null;

    private iconComponentRef!: ComponentRef<IconComponent>;
    private destroy$: Subject<void> = new Subject<void>();
    private el: ElementRef = inject(ElementRef);
    private renderer: Renderer2 = inject(Renderer2);
    private viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
    private injector: Injector = inject(Injector);

    public ngOnInit(): void {
        this.renderer.addClass(this.el.nativeElement, 'nw-menu-trigger-button');
        this.addIcon();

        this.nwMenuTriggerFor?.opened
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.updateIcon(true));

        this.nwMenuTriggerFor?.close
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.updateIcon(false));
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private updateIcon(open: boolean): void {
        if (this.iconComponentRef) {
            this.iconComponentRef.setInput('icon', this.icon(open));
        } else {
            this.addIcon();
        }
    }

    private addIcon(): void {
        this.iconComponentRef = this.viewContainerRef.createComponent(IconComponent, {
            injector: this.injector
        });

        this.iconComponentRef.setInput('icon', this.icon(false));

        this.renderer.appendChild(
            (this.el.nativeElement as HTMLElement).children[0],
            this.iconComponentRef.location.nativeElement
        );
    }

    private icon(open: boolean): Icons.Type {
        return open ? 'chevron-up' : 'chevron-down';
    }
}
